import React, { Component } from 'react';
import { RESOURCE_STATES, OPERATION_TYPES } from '../constants';
const { PUBLISHED, DRAFT } = RESOURCE_STATES;
const { UPDATE, CREATE } = OPERATION_TYPES;

const withCommonUtils = DecoratedComponent => {
  class WrapperComponent extends Component {
    getNewOperationType = resourceConfig => {
      const oldState = resourceConfig.state;
      const oldOperationType = resourceConfig.operation_type;
      if (
        oldState === PUBLISHED ||
        (oldState === DRAFT && oldOperationType === UPDATE)
      ) {
        return UPDATE;
      }
      return CREATE;
    };

    getSingleSelectValue = (options, singleValue) => {
      return options.find(o => o.value === singleValue) || '';
    };

    getMultiSelectValue = (options, valueArray) => {
      return options.filter(o => valueArray.includes(o.value));
    };

    hasDrafts = list => {
      return list.some(item => item.state === DRAFT);
    };

    removeDuplicateEntries = (list, resourcePrimaryKey = 'id') => {
      const draftIdsMap = list.reduce((drafts, item) => {
        if (item.state === 'DRAFT') {
          drafts[item[resourcePrimaryKey]] = true;
        }
        return drafts;
      }, {});

      // remove entries which are both in published and draft stage
      const filteredList = list.filter(item => {
        const { state } = item;
        return !(state === PUBLISHED && draftIdsMap[item[resourcePrimaryKey]]);
      });

      return filteredList;
    };

    render() {
      return (
        <DecoratedComponent
          {...this.props}
          getNewOperationType={this.getNewOperationType}
          getSingleSelectValue={this.getSingleSelectValue}
          getMultiSelectValue={this.getMultiSelectValue}
          hasDrafts={this.hasDrafts}
          removeDuplicateEntries={this.removeDuplicateEntries}
        />
      );
    }
  }

  return WrapperComponent;
};

export default  withCommonUtils;
